import React, { useState } from "react";
import Header from "../layout/header/Header";
import Footer from "../layout/footer/Footer";
import Breadcrumb from "../components/Breadcrumb";
import { HiOutlinePlusSm } from "react-icons/hi";
import { products } from "../json/products";
import { HiOutlineMinusSmall, HiOutlineXMark } from "react-icons/hi2";


function Cart() {
  const [cartItem, setCartItem] = useState(1);

  return (
    <>
      <Header />
      <Breadcrumb title={"Shopping Cart"} />
      <h1 className="font-semibold lg:text-4xl text-center my-10">
        My Shopping Cart
      </h1>
      <div className="container mx-auto mb-20">
        <div className="grid lg:grid-cols-4 gap-5">
          <div className="col-span-3">
            <table className="border border-gray-300 w-full text-left  rounded">
              <thead>
                <tr className="border-b border-gray-300 text-gray-500 w-full">
                  <th className="font-normal uppercase p-3">Products</th>
                  <th className="font-normal uppercase py-3">Price</th>
                  <th className="font-normal uppercase py-3">Quantity</th>
                  <th className="font-normal uppercase py-3">SubTotal</th>
                </tr>
              </thead>
              <tbody>
                {products?.slice(0,1).map((item, i) => (
                  <tr className="border-b border-gray-200 w-full" key={i}>
                    <td className="max-w-1/4 mx-3 flex items-center justify-start">
                      <img
                        src={item?.thumbnail}
                        className="object-contain h-24"
                        alt=""
                      />
                      <p>{item?.name}</p>
                    </td>
                    <td className="w-1/4">${item?.price}</td>
                    <td className="w-1/4">
                      <div className=" border rounded-full max-w-min">
                        <div className="flex items-center p-2 space-x-2">
                          <button
                            className="bg-gray-200 p-1 rounded-full"
                            disabled={cartItem === 0 ? true : false}
                          >
                            <HiOutlineMinusSmall
                              className="w-5 h-5"
                              onClick={() => setCartItem((prev) => prev - 1)}
                            />
                          </button>
                          <input
                            type="text"
                            value={cartItem}
                            className="outline-none focus:outline-none w-5 border-none text-center"
                          />
                          <button
                            className="bg-gray-200 p-1 rounded-full"
                            onClick={() => setCartItem((prev) => prev + 1)}
                          >
                            <HiOutlinePlusSm className="w-5 h-5" />
                          </button>
                        </div>
                      </div>
                    </td>
                    <td className="w-1/4">
                      <div className="flex items-center justify-between space-x-1 pr-5">
                        <p>${item?.price}</p>
                        <button className="bg-gray-200 hover:bg-gray-300 duration-200 p-2 text-xs rounded-full">
                          <HiOutlineXMark className="h-5 w-5" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="col-span-1">
            <SubTotal />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

const SubTotal = () => {
  return (
    <div className="border rounded p-5">
      <p className="font-semibold mb-5 text-black">Cart Total</p>

      <div className="flex items-center justify-between border-b py-5 text-gray-700 border-gray-200">
        <p className="">Subtotal:</p>
        <p className="font-semibold">$549.00</p>
      </div>
      <div className="flex items-center justify-between border-b py-5 border-gray-200 text-gray-700">
        <p>Shipping:</p>
        <p className="font-semibold">Free</p>
      </div>

      <div className="flex items-center justify-between py-5 text-gray-700">
        <p>Total:</p>
        <p className="font-semibold">$549.00</p>
      </div>

      <div className="flex rounded-full mt-3 overflow-hidden">
        <button className="bg-primary w-full px-5 py-2.5 font-semibold text-white">
          Proceed to checkout
        </button>
      </div>
    </div>
  );
};

export default Cart;
